import axiosApiInstance from "redux/axios/axiosApiInstance";
import { getApiUrl } from "utils";

export const getLoginUserValue = (user) => JSON.parse(user);

export const getRequestTypeStage = () => {
  let user = {};
  if (!!localStorage.getItem("RequestTypeStage")) {
    user = JSON.parse(localStorage.getItem("RequestTypeStage"));
  }
  return user;
};

export const getRequestTypes = () => {
  let user = null;
  if (!!localStorage.getItem("RequestTypes")) {
    user = JSON.parse(localStorage.getItem("RequestTypes"));
  }
  return user;
};

export const getRequestTypeDocs = () => {
  let user = null;
  if (!!localStorage.getItem("RequestTypeDocs")) {
    user = JSON.parse(localStorage.getItem("RequestTypeDocs"));
  }
  return user;
};

export const setUserValue = (user) =>
  localStorage.setItem("m_user", JSON.stringify(user));

export const getUserValue = () => {
  let user = {};
  if (!!localStorage.getItem("m_user")) {
    user = JSON.parse(localStorage.getItem("m_user"));
  }
  return user;
};

export const removeUserValue = () => {
  // localStorage.removeItem("m_user");
  localStorage.removeItem("RequestTypeStage");
  localStorage.removeItem("RequestTypes");
  localStorage.removeItem("RequestTypeDocs");
  localStorage.removeItem("MobileRequestNumber");
  localStorage.removeItem("EmailRequestNumber");
  localStorage.removeItem("MobileEmailRequestNumber");
  localStorage.removeItem("BankRequestType");
  localStorage.removeItem("BankRequestNumber");
  localStorage.removeItem("AddressRequestType");
  localStorage.removeItem("AddressRequestNumber");
  localStorage.removeItem("NomineeRequestNumber");
  localStorage.removeItem("IncomeRequestNumber");
  localStorage.removeItem("SegmentRequestNumber");
};

export const getVerifiedAddress = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.get_per_address`,
    payload
  );
};

export const getAddressByPincode = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.apis.address.api.get_data_from_pincode`,
    payload
  );
};

export const getRequestTypeStagesApi = () => {
  return axiosApiInstance.get(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.get_modification_request_types`
  );
};

export const createModifyRequest = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.create_rekyc_modification_request`,
    payload
  );
};

export const createOtpRequest = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.request_otp`,
    payload
  );
};

export const createOtpRequestForBoth = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.request_otp_for_both_case_emailmobile`,
    payload
  );
};

export const otpVerifyRequestForBoth = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.verify_otp_for_both_case_emailmobile`,
    payload
  );
};

export const createOtpVerifyRequest = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.verify_otp`,
    payload
  );
};

export const createReasonApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.get_modifi_reason`,
    payload
  );
};

export const getReviewApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.modifi_review`,
    payload
  );
};

export const submitReviewApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.submit_modifi_review`,
    payload
  );
};

export const requestForEsign = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.request_for_esign`,
    payload
  );
};

// PAN
export const getPanDetailsApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.re_kyc_verification_api.api.pan_details`,
    payload
  );
};

export const getPanNumberApi = (payload = {}) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_validation_apis.api.get_pan_number`,
    payload
  );
};

// phone or email
export const validatePhoneOrEmailApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_validation_apis.api.email_Mobile_validate`,
    payload
  );
};

// Mobile

export const getActiveUserDetailsApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.rekyc_modi_active_user_details`,
    payload
  );
};

export const getPhonePrevReqDetailsApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.previous_rekyc_modif_req_details`,
    payload
  );
};

export const prevPhoneStageDetailsApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.get_modification_request_stages`,
    payload
  );
};

export const createPhoneRequestApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.create_rekyc_modification_request`,
    payload
  );
};

export const createPhoneModifyRequest = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.get_rekyc_modification_details`,
    payload
  );
};

export const createPhoneReasonApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.get_modifi_reason`,
    payload
  );
};

export const getPhoneReviewApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.modifi_review`,
    payload
  );
};

export const submitPhoneReviewApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.submit_modifi_review`,
    payload
  );
};

export const phoneRequestForEsign = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.request_for_esign`,
    payload
  );
};

// Address

export const getPrevAddressRequestApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.previous_address_modif_req_details`,
    payload
  );
};

export const createAddressRequestApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.create_rekyc_address_modification_request`,
    payload
  );
};

export const uploadAddressProofApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.rekyc_verify_address`,
    payload
  );
};

export const getAddressStageApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.get_address_modif_req_stages`,
    payload
  );
};

export const getActiveUserAddress = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.get_user_active_per_address`,
    payload
  );
};

export const getVerifyAddress = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.get_rekyc_verified_address`,
    payload
  );
};

export const updateCommunicationAddress = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.rekyc_comm_address_modi_edit_data`,
    payload
  );
};

export const updatePermanentAddress = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.rekyc_permnt_address_modi_edit_data`,
    payload
  );
};

export const updateVerifyAddress = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.rekyc_address_modi_edit_data`,
    payload
  );
};

export const createDgLockerApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.get_digilocker_url_`,
    payload
  );
};

export const getDataFormDglockerApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.check_fetch_data_from_digilocker`,
    payload
  );
};

export const verifyDgLockerApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.Verify_Digilocker`,
    payload
  );
};

export const verifyAddressApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.rekyc_verify_address`,
    payload
  );
};

export const previousAddressApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.previous_address_modif_req_details`,
    payload
  );
};

export const createAddressModifyRequestApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.create_rekyc_address_modification_request`,
    payload
  );
};

export const getAddressModifyStageApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.get_address_modif_req_stages`,
    payload
  );
};

export const createAddressReasonApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.get_address_modif_req_reason`,
    payload
  );
};

export const getAddressReviewApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.get_address_modif_req_review`,
    payload
  );
};

export const submitAddressReviewApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.submit_address_modifi_review`,
    payload
  );
};

export const addressRequestForEsign = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.add_modif_request_for_esign`,
    payload
  );
};

// Nominee

export const getNomineeStageApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_nominee_modification_apis.api.get_nominee_modif_req_stages`,
    payload
  );
};

export const checkPrevNomineeApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_nominee_modification_apis.api.previous_nominee_modif_req_details`,
    payload
  );
};

export const createNomineeModifyRequestApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_nominee_modification_apis.api.create_rekyc_nominee_modification_request`,
    payload
  );
};

export const wishToAddNomineeApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_nominee_modification_apis.api.rekyc_wish_to_add_nominee`,
    payload
  );
};

export const getNomineeApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_nominee_modification_apis.api.get_rekyc_modi_nominee`,
    payload
  );
};

export const addNomineeApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_nominee_modification_apis.api.add_new_rekyc_nominee`,
    payload
  );
};

export const editNomineeApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_nominee_modification_apis.api.rekyc_update_nominee`,
    payload
  );
};

export const deleteNomineeApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_nominee_modification_apis.api.rekyc_delete_nominee`,
    payload
  );
};

export const activeNomineeModifyRequestApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_nominee_modification_apis.api.add_active_nominee_to_current_req`,
    payload
  );
};

export const createNomineeProofApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_nominee_modification_apis.api.nominee_id_proof`,
    payload
  );
};

export const createNomineeReasonApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_nominee_modification_apis.api.get_nominee_modif_req_reason`,
    payload
  );
};

export const getNomineeReviewApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_nominee_modification_apis.api.get_nominee_modif_req_review`,
    payload
  );
};

export const submitNomineeReviewApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_nominee_modification_apis.api.submit_nominee_modifi_review`,
    payload
  );
};

export const nomineeRequestForEsign = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_nominee_modification_apis.api.add_nominee_request_for_esign`,
    payload
  );
};

// BANK

export const getBankStageApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_bank_modification_apis.api.get_bank_modif_req_stages`,
    payload
  );
};

export const checkPrevBankApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_bank_modification_apis.api.previous_bank_modif_req_details`,
    payload
  );
};

export const createBankModifyRequestApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_bank_modification_apis.api.create_rekyc_bank_modification_request`,
    payload
  );
};

export const verifyBankDetailsApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_bank_modification_apis.api.rekyc_verify_bank_details`,
    payload
  );
};

export const checkPennyDropBankApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_bank_modification_apis.api.get_rekyc_penny_drop_response`,
    payload
  );
};

export const uploadCancelCheque = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_bank_modification_apis.api.rekyc_upload_cancelled_cheque`,
    payload
  );
};

export const updateBankDetails = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_bank_modification_apis.api.rekyc_update_bank_details_api`,
    payload
  );
};

export const setActiveBankApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_bank_modification_apis.api.set_active_bank_details_to_current_request`,
    payload
  );
};

export const getActiveBankApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_bank_modification_apis.api.get_active_bank_details_from_current_request`,
    payload
  );
};

export const updateActiveBankApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_bank_modification_apis.api.set_edited_bank_details_to_current_req`,
    payload
  );
};

export const getPrimaryBankApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_bank_modification_apis.api.get_bank_modif_req_details_for_set_primary`,
    payload
  );
};

export const updatePrimaryBankApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_bank_modification_apis.api.submit_primary_details_to_current_req`,
    payload
  );
};

export const createBankReasonApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_bank_modification_apis.api.get_bank_modif_req_reason`,
    payload
  );
};

export const getBankReviewApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_bank_modification_apis.api.get_bank_modif_req_review`,
    payload
  );
};

export const submitBankReviewApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_bank_modification_apis.api.submit_bank_modifi_review`,
    payload
  );
};

export const bankRequestForEsign = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_bank_modification_apis.api.bank_modif_request_for_esign`,
    payload
  );
};

// INCOME PROOF
export const getPrevIncomeRequestApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_income_proof_modification_apis.api.previous_income_proof_modif_req_details`,
    payload
  );
};

export const createIncomeRequestApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_income_proof_modification_apis.api.create_rekyc_income_proof_modification_request`,
    payload
  );
};

export const getIncomeStageApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_income_proof_modification_apis.api.get_income_proof_modif_req_stages`,
    payload
  );
};

export const validateIncomeProof = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.apis.kyc_verification.api.open_income_proof`,
    payload
  );
};

export const addIncomeProofApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_income_proof_modification_apis.api.add_new_income_proof`,
    payload
  );
};

export const addSegmentIncomeProofApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_segment_modification_apis.api.add_new_income_proof`,
    payload
  );
};

export const createIncomeReasonApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_income_proof_modification_apis.api.get_income_proof_modif_req_reason`,
    payload
  );
};

export const getIncomeReviewApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_income_proof_modification_apis.api.get_income_proof_modif_req_review`,
    payload
  );
};

export const submitIncomeReviewApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_income_proof_modification_apis.api.submit_income_proof_modifi_review`,
    payload
  );
};

export const incomeProofForEsign = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_income_proof_modification_apis.api.add_income_proof_request_for_esign`,
    payload
  );
};

// multiple modification
export const submitMultipleReviewApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_multiple_modification_apis.api.submit_multiple_modifi_review`,
    payload
  );
};

export const multipleRequestForEsign = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_multiple_modification_apis.api.multiple_modif_request_for_esign`,
    payload
  );
};

// DEMAT UCC API
export const mobileEmailUccDematApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.rekyc_modification_request_changes_in_wich_account`,
    payload
  );
};

export const addressUccDematApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.rekyc_add_modification_request_changes_in_wich_account`,
    payload
  );
};

export const bankUccDematApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_bank_modification_apis.api.rekyc_bank_modification_request_changes_in_wich_account`,
    payload
  );
};

export const nomineeUccDematApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_nominee_modification_apis.api.rekyc_nominee_modification_request_changes_in_wich_account`,
    payload
  );
};

export const incomeUccDematApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_income_proof_modification_apis.api.rekyc_incom_proof_modification_request_changes_in_wich_account`,
    payload
  );
};

export const segmentUccDematApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_segment_modification_apis.api.rekyc_segment_modification_request_changes_in_wich_account`,
    payload
  );
};

export const getUccDematDetailApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_multiple_modification_apis.api.get_data_from_req_for_changes_in_which_ac`,
    payload
  );
};

// Segment API
export const getPrevSegmentRequestApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_segment_modification_apis.api.previous_segment_modif_req_details`,
    payload
  );
};

export const createSegmentRequestApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_segment_modification_apis.api.create_rekyc_segment_modification_request`,
    payload
  );
};

export const getSegmentStageApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_segment_modification_apis.api.get_segment_modif_req_stages`,
    payload
  );
};

export const getSegmentDetailApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_segment_modification_apis.api.get_broker_setup_segment_details`,
    payload
  );
};

export const updateSegmentDetailApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_segment_modification_apis.api.set_modified_segment_data_to_segment_req`,
    payload
  );
};

export const createSegmentReasonApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_segment_modification_apis.api.get_segment_modif_req_reason`,
    payload
  );
};

export const getSegmentReviewApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_segment_modification_apis.api.get_segment_modif_req_review`,
    payload
  );
};

export const submitSegmentReviewApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_segment_modification_apis.api.submit_segment_modifi_review`,
    payload
  );
};

export const segmentForEsign = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_segment_modification_apis.api.add_segment_request_for_esign`,
    payload
  );
};

// Correspondence address
export const verifyCorrespondenceAddress = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.rekyc_document_needed_in_correspondance_address_for_ocr`,
    payload
  );
};

export const verifyCorrespondenceOtherAddress = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.rekyc_other_correspondence_Address_verification`,
    payload
  );
};

// demat & ucc number api

export const getDematNumberApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_validation_apis.api.get_demat_number`,
    payload
  );
};

export const getTradingNumberApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_validation_apis.api.get_trading_number`,
    payload
  );
};

// KRA
export const addMobileOrEmailKra = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.rekyc_modification_request_get_kra_details`,
    payload
  );
};

export const addAddressKra = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.rekyc_modification_request_get_kra_details`,
    payload
  );
};

export const sendDataToKraApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.rekyc_want_to_send_data_to_kra`,
    payload
  );
};

// Reactivation API

export const createReactivateDetailApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.re_kyc_reactivation_apis.api.create_rekyc_activation_request`,
    payload
  );
};

export const reactivateUccDematApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.re_kyc_reactivation_apis.api.reactivation_changes_in_which_account`,
    payload
  );
};

export const reactivateForSendPdfApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.re_kyc_reactivation_apis.api.reactivation_send_unsigned_pdf`,
    payload
  );
};

export const reactivateForEsignApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.re_kyc_reactivation_apis.api.reactivation_request_for_esign`,
    payload
  );
};

export const validateReactivateReqApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.re_kyc_reactivation_apis.api.check_previous_reactivation_request_validation`,
    payload
  );
};

export const uploadReactivateProofApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.update_rekyc_reactivation_addressv2`,
    payload
  );
};

export const updateReactivateAddressApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_address_modification_apis.api.rekyc_reactivation_address_modi_edit_data`,
    payload
  );
};

export const addReactivatePersonalInfoApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.re_kyc_reactivation_apis.api.add_personal_info`,
    payload
  );
};

export const uploadReactivateIncomeApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_income_proof_modification_apis.api.update_rekyc_reactivation_income`,
    payload
  );
};

export const uploadReactivateVisualVerifyApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_validation_apis.api.upload_rekyc_visual_verification`,
    payload
  );
};

export const submitReactivateVisualVerifyApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_validation_apis.api.confirm_rekyc_visual_verification`,
    payload
  );
};

export const getReactivateStageApi = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.api.get_rekyc_request_stages`,
    payload
  );
};

export const sendSessionStartMail = (payload) => {
  return axiosApiInstance.post(
    `${getApiUrl()}/api/method/kyc_customizations.re_kyc.apis.rekyc_modification_apis.endpoints.get_rekyc_session_mail.send_rekyc_session_mail`,
    payload
  );
};
